export * from "/opt/build/repo/node_modules/lodash/lodash.js"